/**
 * Include your custom JavaScript here.
 */

// ==========================================
// 1. KEYPO MIGRATION UPDATE (SAFE EVENT DELEGATION)
// ==========================================
console.log("[KeyPO Custom] Script injected at the top!");

// --- 1A. ADD TO CART INTERCEPT ---
document.addEventListener("click", async function(event) {
  var btn = event.target.closest('button[type="submit"], .ProductForm__AddToCart');
  var isCartButton = btn && (btn.closest('buy-buttons') || btn.closest('form[action*="/cart/add"]'));
  
  if (isCartButton) {
    console.log("[KeyPO Custom] 'Add to Cart' button click detected!");
    
    if (window.KeyOptions && window.KeyOptions.getCurrentOptions) {
      var state = window.KeyOptions.getCurrentOptions();
      var visibleProps = state.properties.visible || {};
      var keepsakeValue = visibleProps['+Personalised Keepsake Box:'] || visibleProps['Personalised Keepsake Box:'];

      if (keepsakeValue === 'Yes Please! ( +€5.95 )' && !btn.dataset.keepsakeAdded) {
        console.log("[KeyPO Custom] Intercepting click. Halting native submission...");
        
        event.preventDefault(); 
        event.stopImmediatePropagation(); 
        
        var titleEl = document.querySelector('.ProductMeta__Title') || document.querySelector('h1');
        var title = titleEl ? titleEl.textContent.trim() : '';

        try {
          console.log("[KeyPO Custom] Firing non-blocking async fetch request for Keepsake Box...");
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              'items': [{
                'quantity': 1,
                'id': 39382959882298,
                'properties': {
                  'Associated Product': title
                }
              }]
            })
          });
          console.log("[KeyPO Custom] Success! Keepsake Box added to cart backend.");
        } catch (error) {
          console.error("[KeyPO Custom] Error: Failed to add Keepsake Box", error);
        }

        btn.dataset.keepsakeAdded = 'true';
        console.log("[KeyPO Custom] Re-triggering native add-to-cart...");
        btn.click();

        setTimeout(() => { 
          delete btn.dataset.keepsakeAdded; 
        }, 1000);

        return false; 
      }
    }
  }
}, true);


// --- 1B. CART REMOVE INTERCEPT ---
document.addEventListener("click", async function(event) {
  // Broad selector to catch native remove links and custom OS 2.0 remove buttons
  var removeBtn = event.target.closest('.CartItem__Remove, a[href*="/cart/change"][href*="quantity=0"], cart-remove-button, button[data-action="remove-item"]');
  
  if (removeBtn) {
    console.log("[KeyPO Custom] Cart remove intercepted.");
    event.preventDefault();
    event.stopImmediatePropagation();

    try {
      var cartRes = await fetch('/cart.json');
      var cart = await cartRes.json();

      var idToRemove = removeBtn.getAttribute('data-id') || removeBtn.dataset.id;
      var lineToRemove = removeBtn.getAttribute('data-line') || removeBtn.dataset.line;

      if (!idToRemove && removeBtn.href) {
        var url = new URL(removeBtn.href, window.location.origin);
        idToRemove = url.searchParams.get('id');
        lineToRemove = url.searchParams.get('line');
      }

      var mainItem = null;
      if (idToRemove) {
        mainItem = cart.items.find(function(item) { 
          return item.key === idToRemove || item.variant_id == idToRemove || item.id == idToRemove; 
        });
      } else if (lineToRemove) {
        mainItem = cart.items[parseInt(lineToRemove) - 1];
      }

      if (!mainItem) {
        console.warn("[KeyPO Custom] Could not identify item. Falling back to default remove.");
        if (removeBtn.href) window.location.href = removeBtn.href;
        return;
      }

      var mainTitle = (mainItem.product_title || mainItem.title).trim();
      var updates = {};
      updates[mainItem.key] = 0; // Remove main item

      // Find associated items
      cart.items.forEach(function(item) {
        if (item.properties && item.properties['Associated Product']) {
          var associatedVal = item.properties['Associated Product'];
          if (associatedVal.indexOf(mainTitle) !== -1 || mainTitle.indexOf(associatedVal) !== -1) {
            updates[item.key] = 0; // Mark associated product for removal
            console.log("[KeyPO Custom] Found linked product to remove:", item.title);
          }
        }
      });

      console.log("[KeyPO Custom] Sending bulk remove update:", updates);
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });

      console.log("[KeyPO Custom] Successfully removed. Reloading...");
      window.location.reload();

    } catch (err) {
      console.error("[KeyPO Custom] Remove logic failed", err);
      if (removeBtn.href) window.location.href = removeBtn.href;
    }
  }
}, true);


// ==========================================
// 2. LEGACY THEME CODE (WRAPPED IN TRY-CATCH)
// ==========================================
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".legacy-collection-filters").forEach(function(filters) {
    var drawer = filters.querySelector(".mobile_filter_drag");
    var openButton = filters.querySelector(".mobile_filter > button.SortTags");
    var openIcon = filters.querySelector(".mobile_filter > svg");
    var closeButton = filters.querySelector(".close_wrapper");
    var applyButton = filters.querySelector(".Button--apply");
    var collectionUrlInput = document.querySelector(".input_wrapper");

    function getCollectionUrl() {
      return collectionUrlInput && collectionUrlInput.value ? collectionUrlInput.value : window.location.pathname.split("?")[0];
    }

    function getSelectedFilterUrl() {
      var selectedHandles = [];

      filters.querySelectorAll(".product_filters input:checked").forEach(function(input) {
        var handle = input.getAttribute("data-url");

        if (handle && selectedHandles.indexOf(handle) === -1) {
          selectedHandles.push(handle);
        }
      });

      return selectedHandles.length > 0 ? getCollectionUrl() + "/" + selectedHandles.join("+") : getCollectionUrl();
    }

    function openDrawer(event) {
      if (event) {
        event.preventDefault();
      }

      if (drawer) {
        drawer.classList.add("active");
      }
    }

    function closeDrawer(event) {
      if (event) {
        event.preventDefault();
      }

      if (drawer) {
        drawer.classList.remove("active");
      }
    }

    async function applySelectedFilters(event) {
      if (event) {
        event.preventDefault();
      }

      var filterUrl = getSelectedFilterUrl();
      var currentCollectionMain = document.querySelector(".collection__main");

      if (!currentCollectionMain) {
        return;
      }

      currentCollectionMain.setAttribute("aria-busy", "true");

      try {
        var response = await fetch(filterUrl);
        var html = await response.text();
        var parsedDocument = new DOMParser().parseFromString(html, "text/html");
        var nextCollectionMain = parsedDocument.querySelector(".collection__main");

        if (nextCollectionMain) {
          currentCollectionMain.innerHTML = nextCollectionMain.innerHTML;
        }

        closeDrawer();
      } catch (error) {
        console.error("[Legacy collection filters] Unable to load filtered products", error);
      } finally {
        currentCollectionMain.removeAttribute("aria-busy");
      }
    }

    if (openButton) {
      openButton.addEventListener("click", openDrawer);
    }

    if (openIcon) {
      openIcon.addEventListener("click", openDrawer);
    }

    if (drawer) {
      drawer.addEventListener("click", function(event) {
        event.stopPropagation();
      });
    }

    if (closeButton) {
      closeButton.addEventListener("click", closeDrawer);
    }

    if (applyButton) {
      applyButton.addEventListener("click", applySelectedFilters);
    }

    filters.querySelectorAll(".product_filters input").forEach(function(input) {
      input.addEventListener("change", function() {
        applySelectedFilters();
      });
    });
  });
});

document.addEventListener("DOMContentLoaded", function() {
  var giftWrapper = document.querySelector(".cart_mobile_number_with_checkbox");

  if (!giftWrapper) {
    return;
  }

  var giftCheckbox = giftWrapper.querySelector(".Show_Mobile_Number");
  var mobileFieldWrapper = giftWrapper.querySelector(".cart-INPUT__field");
  var mobileInput = giftWrapper.querySelector("#mobile-number");
  var mobileError = giftWrapper.querySelector(".highlight-red");
  var cartForm = giftWrapper.closest("form");
  var hideMobileErrorTimeout;

  function hideMobileError() {
    if (mobileError) {
      mobileError.hidden = true;
    }

    if (mobileInput) {
      mobileInput.removeAttribute("aria-invalid");
      mobileInput.setCustomValidity("");
    }
  }

  function showMobileError() {
    if (mobileError) {
      mobileError.hidden = false;
    }

    if (mobileInput) {
      mobileInput.setAttribute("aria-invalid", "true");
      mobileInput.setCustomValidity("Please Enter Mobile Number");
      mobileInput.focus();
    }

    window.clearTimeout(hideMobileErrorTimeout);
    hideMobileErrorTimeout = window.setTimeout(hideMobileError, 6000);
  }

  function syncGiftMobileField() {
    var shouldRequireMobile = giftCheckbox && giftCheckbox.checked;

    if (giftCheckbox) {
      giftCheckbox.value = shouldRequireMobile ? "Yes" : "No";
      giftCheckbox.setAttribute("value", giftCheckbox.value);
    }

    if (mobileFieldWrapper) {
      mobileFieldWrapper.hidden = !shouldRequireMobile;
    }

    if (mobileInput) {
      mobileInput.toggleAttribute("required", shouldRequireMobile);

      if (!shouldRequireMobile) {
        mobileInput.value = "";
        hideMobileError();
      }
    }
  }

  function validateGiftMobileNumber(event) {
    if (!giftCheckbox || !giftCheckbox.checked || !mobileInput) {
      return true;
    }

    if (mobileInput.value.trim()) {
      hideMobileError();
      return true;
    }

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    showMobileError();
    return false;
  }

  syncGiftMobileField();

  if (giftCheckbox) {
    giftCheckbox.addEventListener("change", syncGiftMobileField);
  }

  if (mobileInput) {
    mobileInput.addEventListener("input", function() {
      if (mobileInput.value.trim()) {
        hideMobileError();
      }
    });
  }

  if (cartForm) {
    cartForm.addEventListener("submit", validateGiftMobileNumber);
  }

  document.addEventListener("click", function(event) {
    var checkoutButton = event.target.closest('button[name="checkout"], input[name="checkout"]');

    if (checkoutButton && cartForm && cartForm.contains(checkoutButton)) {
      validateGiftMobileNumber(event);
    }
  }, true);
});

try {
  if (typeof $ !== 'undefined' && $.fn && $.fn.flickity) {    
    $('.AnnouncementBar__Wrapper').flickity({
      "prevNextButtons": false,
      "setGallerySize": false,
      "adaptiveHeight": false,
      "wrapAround": true,
      "dragThreshold": 15,
      "pauseAutoPlayOnHover": false,
      "autoPlay": 3000,
      "pageDots": false
    });
  } else {
    console.warn("[KeyPO Custom] jQuery or Flickity not found, skipping slider init.");
  }

  if (typeof $ !== 'undefined') {
    $(".product_filters ul li").click(function(){
      var res = '';
      $(".product_filters ul li input:checked").each(function(){
        res += $(this).attr("data-url")+'+';
      });   
      res = res.substring(0,  res.length - 1);
      var collurl = $(".input_wrapper").val();
      var final =  collurl+'/'+res;
      $.ajax({
          url:  final,
          type: 'GET',
          dataType: 'html'
        })
        .done(function(data) {
          var finalot = $(data).find(".CollectionInner .CollectionInner__Products").html();
          $(".CollectionInner .CollectionInner__Products").html(finalot);
          $(".js .features--show-element-staggering .ProductList--grid .ProductItem").css("visibility","visible");
          if($(window).width()<= 749){
            $( ".mobile_filter_drag" ).removeClass( "active" );
          }
        }); 
    });

    $(document).ready(function(){
      $(".mobile_filter").click(function(){ $(".mobile_filter_drag").addClass("active"); });
      $(".close_wrapper").click(function(){ $( ".mobile_filter_drag" ).removeClass( "active" ); });
      $(".Button--apply").click(function(){ $( ".mobile_filter_drag" ).removeClass( "active" ); });
    });

    $(".rating").click(function() {
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#judgeme_product_reviews").offset().top
        }, 2000);
    });

    $(".radio-chk input[radio]").change(function(event){
      var p = $("#messageChk1:checked").val();
      if(p=="1"){
        $(".optional-cart-message").attr("required","required");
        $(".CartSpecialInstructions").attr("required","required");
      }else{
        $(".optional-cart-message").removeAttr("required");
        $(".CartSpecialInstructions").removeAttr("required");
      }
    });

    $(document).on('click', 'button.Cart__Checkout', function(e){
      if($(".Show_Mobile_Number").is(":checked")){
        if(!$("input#mobile-number").val()){
          $(".highlight-red").show();
          setTimeout(function(){ $(".highlight-red").hide(); }, 6000);
          e.preventDefault();
        }
      }
      if($("#messageChk1").is(":checked")){
         if(!$("#CartSpecialInstructions").val()){
          $(".highlight-red-2").show();
          setTimeout(function(){ $(".highlight-red-2").hide(); }, 6000);
          e.preventDefault();
        }
      }
    });

    $(document).on("click", "input.Show_Mobile_Number", function(){
      if($(this).is(":checked")){
        $(this).val("Yes").attr("value", "Yes");
        $("p.cart-attribute__field.cart-INPUT__field").show();
      }else{
        $(this).val("No").attr("value", "No");
        $("p.cart-attribute__field.cart-INPUT__field").hide();
      }
    });
  }
} catch(err) {
  console.error("[Legacy Code Error] Captured error to prevent crash:", err);
}

function isNumber(evt) {
  evt = (evt) ? evt : window.event;
  var charCode = (evt.which) ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
  }
  return true;
}

try {
  if (typeof $ !== 'undefined') {
    if($("[name='properties[Message For Engraving]']").length > 0){   
      $("[name='properties[Message For Engraving]']").parents('label').css('display','none');
      $("select option[value='No engraving required']").attr("selected",true);
      $(".template-product .bold_options .bold_option_set").find("input[type*='radio']").parents(".bold_option_set").addClass("checkbox-parent-div").children().removeClass("checkbox-parent-div");
    }
     
    if($("[name='properties[Message For Engraving]']").length > 0){   
      $("[name='properties[Complimentary Engraving?]']").parents('label').parents('.bold_option bold_option_dropdown').addClass('mesg112');
      $("[name='properties[Complimentary Engraving?]']").addClass('complimentary');
      $("[name='properties[Message For Engraving]']").parents('label').parents().addClass('mesg');
       
      $('[name="properties[Complimentary Engraving?]"]').on('change', function(){
        var select_value1 = $('[name="properties[Complimentary Engraving?]"]').val();
        if(select_value1 == 'No engraving required'){
          $("[name='properties[Message For Engraving]']").parents('label').css('display','none');
        } else {
          $("[name='properties[Message For Engraving]']").css('display','block'); 
          $("[name='properties[Message For Engraving]']").parents('label').css('display','block');
        }
      });
       
      $('select.complimentary option').filter(function() {
          return !this.value || $.trim(this.value).length == 0 || $.trim(this.text).length == 0;
      }).remove();
    }
  }
} catch(err) {}

// ==========================================
// 3. UI TWEAKS (HIDE CART ELEMENTS FOR KEEPSAKE BOX)
// ==========================================
document.addEventListener("DOMContentLoaded", function() {
  function hideKeepsakeCartElements() {
    // Target all table rows (<tr>) in the cart
    document.querySelectorAll('tr').forEach(row => {
      
      // Target ONLY the product title element (not the entire row text)
      let titleEl = row.querySelector('.line-item-info a.h6, .line-item-info a');
      
      if (titleEl) {
        let titleText = titleEl.textContent || titleEl.innerText;
        
        // Check if the actual product title includes 'personalised keepsake box'
        if (titleText.toLowerCase().includes('personalised keepsake box')) {
          
          // Hide the container holding the QTY selector and Remove button for this specific item
          let actionAreas = row.querySelectorAll('line-item-quantity');
          actionAreas.forEach(area => {
            area.style.display = 'none';
          });
        }
      }
    });
  }

  // Run the function on initial page load
  hideKeepsakeCartElements();

  // MutationObserver ensures elements stay hidden even if the cart updates dynamically via AJAX
  const cartObserver = new MutationObserver(() => {
    hideKeepsakeCartElements();
  });
  cartObserver.observe(document.body, { childList: true, subtree: true });
});